import React, { useState, memo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Layout, Menu, Icon, Typography, Switch } from 'antd'
import {Link} from 'gatsby';
import logo from '@static/logo.png'
import linkedIn from '@static/download.png'
import emaild from '@static/mail.png'
import emailw from '@static/mailw.png'

import ghubd from '@static/ghubd.png'
import ghubw from '@static/ghubw.png'

const LandingLayout = ({ children, activeTab, lState }) => {
  const [collapsed, toggle,] = useState(true)
  const [ light, setValue, ] = useState(!lState)
  return (
    <div className='landing-layout'>
      <Layout
      theme= {light ? 'light' : 'dark'}
      >
        <Layout.Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          theme= {light ? 'light' : 'dark'}
        >
          <div className='h-20 m-2 flex items-center justify-around'>
            {/*<LogoIcon className='h-10 w-10 mr-2 fill-primary-color' />*/}
            <img src={logo} height='45' width='45' alt="Logo"/>
            <Typography.Title
              level={4}
              className={classNames('text-primary-color', {
                hidden: collapsed,
              })}
            >
              {process.env.APP_NAME}
            </Typography.Title>
          </div>
          <Menu
            theme= {light ? 'light' : 'dark'}
            mode='inline'
            defaultSelectedKeys={[activeTab]}
            className='border-0'
          >
            <Menu.Item key='1'>
              <Link className='navbar-item' to={light ? '/' : '/dark'}>
                <Icon type='user' />
                <span>About Me</span>
              </Link>
            </Menu.Item>
            <Menu.Item key='2'>
              <Link className='navbar-item' to={light ? '/projects' : '/projects/dark'}>
                <Icon type='project' />
                <span>My Projects</span>
              </Link>
            </Menu.Item>
            <Menu.Item key='3'>
            <Link className='navbar-item' to={light ? '/contact' : '/contact/dark'}>
              <Icon type='mail' />
              <span>Contact Me</span>
              </Link>
            </Menu.Item>
          </Menu>
        </Layout.Sider>
        <Layout
          theme= {light ? 'light' : 'dark'}
          style={{ background: light ? '#f0f2f5' : '#000000', padding: 0 }}
          >
          <Layout.Header style={{ background: light ? '#fff' : '#001529', padding: 0 }}>
            <Icon
              className='leading-normal ml-4 text-base'
              type={collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={() => toggle(!collapsed)}
              style={{
                color: light ? '#000' : '#ab8',
              }}
            />
            <Switch
            className='leading-normal ml-4 text-base'
            checked={light}
            onChange = {() => setValue(!light)}
            />
          </Layout.Header>
          <Layout.Content
            style={{
              margin: '24px 16px',
              padding: 24,
              background: light ? '#fff' : '#001529',
              minHeight: 280,
            }}
          >
            <div style={{ minHeight: '100vh' }}>{children}</div>
          </Layout.Content>
          <Layout.Footer style={{ background: light ? '#fff' : '#001529', padding: 5,}}>
          <div className='flex items-center justify-center'>
            <a href='https://www.linkedin.com/in/basel-s/'> <img src = {linkedIn} width='25' height='25'/></a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href='mailto:bsaleh03@gmail.com'> <img src = {light ? emaild : emailw} width='25' height='25'/></a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href='https://github.com/bsaleh03'> <img src = {light ? ghubd : ghubw} width='25' height='25'/></a>
          </div>
          </Layout.Footer>
        </Layout>
        
      </Layout>
    </div>
  )
}

LandingLayout.propTypes = {
  children: PropTypes.node.isRequired,
  activeTab: PropTypes.node.isRequired,
  lState: PropTypes.node.isRequired
}

export default memo(LandingLayout)
